import { useSelector } from 'react-redux';
import { firstModalInQueueSelector } from './slice';

export const useActiveModal = () => useSelector(firstModalInQueueSelector);
